module.exports = __webpack_public_path__ + "c_static/img/拼多多店铺名.cb6095f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/拼多多店铺名.png
// module id = Ij68
// module chunks = 33